export enum CustomSettingKey {
	CALENDAR_SETTINGS = 'calendar_settings',
	CALENDAR_NOTIFICATIONS_SETTINGS = 'calendar_notifications_settings',
}
